import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DispatchLocation } from '../models';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class DispatchLocationService {
    constructor(public apiService: ApiService) { }

    assignLocationToDispatch(request: DispatchLocation): Observable<any> {
        return this.apiService.put(`${this.apiService.dispatch}/locate`, request);
    }
}
